import { isEqual } from "lodash";
import { IUser } from "../slices/userSlice";


export const transformUserDetailsForDisplay = (user): IUser => {
    const returnValue: IUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        displayName: user.displayName,
        description: user.description,
        timezone: user.timezone || '',
        password: user.password,
        isAdmin: user.isAdmin || false,
        tenantId: user.tenantId,
        roles: user.roles.map((role) => role.id),
        teams: user.teams.map((team) => team.id)
    };
    return returnValue;
}

export const transformUserDetailsForPatch = (user: IUser, userRedux: IUser) => {
    const { password, id, ...remainingKeys } = user;
    const keys = Object.keys(remainingKeys);
    const returnValue = [];
    keys.forEach((key) => {
        if (!isEqual(user[key], userRedux[key])) {
            returnValue.push({
                op: 'replace',
                path: `/${key}`,
                value: user[key]
            })
        }
    })
    return {
        id,
        payload: returnValue
    };
}